import { ComboBoxDropdownItem } from '../types/comboBoxDropdownItem'
import { ComboBoxItem } from '../types/comboBoxItem'
import { ComboBoxValue } from '../types/comboBoxValue'
import { getItemFromValue } from './getItemFromValue'

interface GetSelectedItemsFromValuesOptions {
  isItemValid: (item: ComboBoxItem) => boolean
  items: ComboBoxDropdownItem[]
  selectedValues: ComboBoxValue[]
}
export const getSelectedItemsFromValues = ({ isItemValid, items, selectedValues }: GetSelectedItemsFromValuesOptions) =>
  selectedValues.map((selectedValue) => {
    const item = items.find((item) => item.value.value === selectedValue) || getItemFromValue(selectedValue)
    return { ...item, isValid: isItemValid(item) }
  })
